import React from "react";
import styles from "./AstroCard.module.scss";
import {  RoomResponse } from "../../Enum";
import Image from "next/image";
import { TriggerCallRedirectEvent } from "../../../../utils/events/events.helpers";
import { EventNames } from "../../../../utils/events";
import useDomainFilePick from "../../../../customhooks/useDomainFilePick";

interface AstroCardProps {
  data: RoomResponse[];
}

const AstroCard = ({ data }: AstroCardProps) => {
  const { hostname } = useDomainFilePick();

  const onCardClick = (id: string) => {
    let baseUrl = "https://chingari.io";
    if (hostname === "astrolive") {
      baseUrl = baseUrl.replace("chingari.io", "astrolive.app");
    }
    TriggerCallRedirectEvent(EventNames.DeepLink, {
      page: `${baseUrl}/call?id=${id}`,
    });
  };

  return (
    <div className={styles.cardsWrapper}>
      {data.map((element, index) => {
        return (
          <div className={styles.astroCard} key={index}>
            <div className={styles.logoWrapper}>
              <Image
                src={element?.userProfile?.photo}
                alt="astro-image"
                height={56}
                width={56}
              />
            </div>
            <p>{element?.userProfile?.name}</p>
            {/* <span>
              <Image
                src={Images.diamondPurple}
                alt="diamond"
                height={10}
                width={10}
              />
              <span>{element?.liveRoom?.diamonds}/min</span>
            </span> */}
            <button
              onClick={() => onCardClick(element?.userProfile?.userId ?? "")}
            >
              Chat
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default AstroCard;
